import { NgOptimizedImage } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  selector: 'kh-footer',
  imports: [NgOptimizedImage],
  template: `
    <footer
      class="px-4 py-2 text-md text-white flex justify-between items-center"
    >
      <div>
        <img
          alt="Kimley-Horn Logo"
          width="105"
          height="20"
          ngSrc="KH_footer_logo.png"
          priority
        />
      </div>
      <div>
        <span>Copyright {{ currentYear }}. All Rights Reserved.</span>
      </div>
    </footer>
  `,
})
export class FooterComponent {
  currentYear = new Date().getFullYear()
}
